<div id="enquiryDetailsChartModal" style="width: 100%; height: 400px; background-color: #FFFFFF;"></div>
